const React = require('react');
const cx = require('classnames');
const Button = require('react-bootstrap').Button;

const SuppressedEmailsStore = require('../../stores/SuppressedEmailsStore');
const UserStore = require('../../stores/UserStore');
const SuppressedEmailActions = require('../../actions/SuppressedEmailActions');
const Loading = require('../../components/Loading');

function getState() {
    const data = SuppressedEmailsStore.get();

    return {
        loading:       SuppressedEmailsStore.loading() || UserStore.loading(),
        saving:        data.saving,
        recentlySaved: data.recentlySaved,
        suppressions:  data.suppressions,
        roles:         UserStore.getCurrentRoles()
    };
}

const Settings = React.createClass({
    componentDidMount: function() {
        SuppressedEmailsStore.addChangeListener(this.update);
    },
    componentWillMount: function () {
        SuppressedEmailActions.getSuppressedEmails();
    },
    componentWillUnmount: function () {
        SuppressedEmailsStore.removeChangeListener(this.update);
    },
    getInitialState: function () {
        return getState();
    },
    render: function () {
        return <div>
            <h1>Settings</h1>
            <section className="powerwidget">
                <header><h2>Email opt-out settings</h2></header>
                <div className="inner-spacer">
                    <form onSubmit={this.save}>
                        {this.state.loading
                            ? <Loading />
                            : <div>
                                {this.renderOptOuts()}
                                <p style={{marginTop: 30}}>
                                    <Button bsStyle="success" type="submit" className={cx({ disabled: this.state.loading || this.state.saving })}>
                                        <i className="fa fa-floppy-o"></i> Save
                                    </Button>
                                    &nbsp;
                                    {this.state.saving ? <Loading id="saving" message="Saving ..." /> : null}
                                    {this.state.recentlySaved ? <span id="saved" className="fade-out">Saved!</span> : null}
                                </p>
                            </div>}
                    </form>
                </div>
            </section>
        </div>;
    },
    renderOptOuts: function () {
        const isOwner = this.state.roles.indexOf('OWNER') !== -1;
        console.log(this.state);
        return <div>
            <div className="checkbox">
                <label>
                    <input
                        ref="usage_warnings"
                        type="checkbox"
                        defaultChecked={this.state.suppressions.indexOf('usage-warnings') !== -1}
                    /> Opt out of usage alerts (near limit / over limit warnings)
                </label>
            </div>
            {isOwner || <div className="checkbox">
                <label>
                    <input
                        ref="overdue_notices"
                        type="checkbox"
                        defaultChecked={this.state.suppressions.indexOf('overdue-notices') !== -1}
                    /> Opt out of overdue invoice warnings
                </label>
            </div>}
            {<div className="checkbox">
                <label>
                    <input
                        ref="marketing_emails"
                        type="checkbox"
                        defaultChecked={this.state.suppressions.indexOf('marketing-emails') !== -1}
                    /> Opt out of promotional marketing materials
                </label>
            </div>}
        </div>;
    },
    save: function (e) {
        e.preventDefault();
        let suppressions = [];

        if (this.refs.usage_warnings.getDOMNode().checked) {
            suppressions.push('usage-warnings');
        }
        if (this.refs.overdue_notices && this.refs.overdue_notices.getDOMNode().checked) {
            suppressions.push('overdue-notices');
        }
        if (this.refs.marketing_emails && this.refs.marketing_emails.getDOMNode().checked) {
            suppressions.push('marketing-emails');
        }

        SuppressedEmailActions.updateSuppressedEmails(suppressions);
    },
    update: function() {
        this.setState(getState());
    }
});

module.exports = Settings;



// WEBPACK FOOTER //
// ./app/components/Settings/Settings.js